import { Flex, Skeleton, Text, VStack } from "@chakra-ui/react";
import { HashLoader } from "react-spinners";

export const Loader = ({ title = "Please wait...", height = "90vh" }) => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      h={height}
      flexDir="column"
      textAlign="center"
    >
      {/* <Spinner thickness="4px" color="brand.100" size="lg" /> */}
      <HashLoader color="#0F172A" size={80} />
      <Text pt="4" fontWeight="500">
        {title}
      </Text>
    </Flex>
  );
};

export const PageLoader = ({ squares }: { squares?: boolean }) => {
  return (
    <VStack w={"full"} alignItems={"flex-start"} spacing={squares ? 3 : 2}>
      <Skeleton
        borderRadius={squares ? "8px" : "0px"}
        w={"full"}
        height={"32px"}
      />
      <Skeleton
        borderRadius={squares ? "0px" : "0px"}
        w={squares ? "full" : "80%"}
        height={squares ? "32px" : "18px"}
      />
      <Skeleton
        borderRadius={squares ? "8px" : "0px"}
        w={squares ? "full" : "60%"}
        height={squares ? "32px" : "18px"}
      />
    </VStack>
  );
};
